// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components
import CertificationCard from "./CertificationCard";

// Data / Images / Icons
import { CERTIFICATIONS } from "src/data/pages/certifications";

function CertificationCardGroup() {
    return (
        <div className="max-w-4xl mx-auto px-10">
          <div className="space-y-6">
            {CERTIFICATIONS.map((cert) => (
              <CertificationCard key={cert.id} certification={cert} />
            ))}
          </div>
        </div>
    );
  }
  
  export default CertificationCardGroup;